module.exports = __webpack_public_path__ + "60c64d93cb391790b2d3e32c8c4cc894.glb";